<mat-card
  [@cardAnimator]="animationState"
  (@cardAnimator.done)="resetAnimationState()"
  class="contrast"
  [class.banner-info]="selected"
  [class.banner-warning]="item?.disabled"
  [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxFlex="40" fxLayoutAlign="start center" fxLayout="row">
      <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.description | encodeHtml | highlight: searchValue"></strong>
    </div>
    <div fxFlex="60" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="18px">
      <div [fxFlex]="readonly ? 100 : 70" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign.lt-sm="center center" class="date-text">
        <!-- This can be implemented when the metadata is ready -->
        <div [ngClass.lt-sm]="{'item-metadata': true}" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="5px" fxLayoutAlign.lt-sm="center center">
          <!-- <mat-icon matTooltip="Product Manual Missing">menu_book</mat-icon>
          <mat-icon matTooltip="Image Missing">image</mat-icon>
          <mat-icon matTooltip="Video Missing">movie</mat-icon>
          <mat-icon matTooltip="3D Model Missing">view_in_ar</mat-icon> -->
          <mat-icon *ngIf="readonly" [color]="item?.callerReferenceKey ? 'accent' : 'primary'" [matTooltip]="item?.callerReferenceKey ? 'High Res Asset Linked' : 'High Res Asset Not Linked'">dataset_linked</mat-icon>
          <div fxHide.lt-sm class="m-l-10 m-r-10">|</div>
        </div>
        <p><small>sku</small>&nbsp;</p>
        <div [innerHtml]="item?.sku | encodeHtml | highlight: searchValue"></div>
        <div *ngIf="item?.brand" fxHide.lt-sm class="lhm-10px-spacing rhm-10px-spacing">|</div>
        <p *ngIf="item?.brand"><small>brand</small></p>
        <div>&nbsp;{{ item?.brand }}</div>
      </div>
      <div *ngIf="!readonly" [fxFlex]="readonly ? 0 : 30" fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
        <tag-picker
            (addTagRequest)="addTag($event)"
            (removeTagRequest)="removeTag($event)"
            [allTags]="tags"
            [assignedTagIds]="item.tagIds"
            [resourceType]="resourceTypeEnum"
            [allowAddTag]="false">
          </tag-picker>
      </div>
    </div>
  </mat-card-content>
</mat-card>